import _cloneDeep from 'lodash/cloneDeep';
import _findIndex from 'lodash/findIndex';
import _isEqual from 'lodash/isEqual';

export default {
  props: {
    // The v-model bound value.
    // Allows one to control the visibility.
    // If value is an Array, the array contains the value.
    visibleValue: {
      required: false,
      default: false,
    },
    // Sets the value of the visible control component
    value: {
      required: false,
      default: null
    }
  },
  model: {
    prop: 'visibleValue',
    event: 'input'
  },
  computed: {
    computedValue () {
      return this.isVisibleValueBoolean ? this.visibleValue : this.value;
    },
    isVisibleValueMultiple () {
      return Array.isArray(this.visibleValue);
    },
    isVisibleValueBoolean () {
      return typeof this.visibleValue === 'boolean';
    },
    visible () {
      let visible;

      if (this.isVisibleValueMultiple) {
        visible = this.visibleValue.some(visible => _isEqual(visible, this.computedValue));
      } else if (this.isVisibleValueBoolean) {
        visible = this.visibleValue;
      } else {
        visible = _isEqual(this.computedValue, this.visibleValue);
      }

      return visible;
    }
  },
  methods: {
    setVisible (visible) {
      if (this.visible !== visible) {
        if (this.isVisibleValueMultiple) {
          const clone = _cloneDeep(this.visibleValue);
          let ix = _findIndex(clone, item => _isEqual(item, this.computedValue));

          if (visible) {
            if (ix === -1) {
              clone.push(_cloneDeep(this.computedValue));
            }
          } else {
            clone.splice(ix, 1);
          }

          this.$emit('input', clone);
        } else if (this.isVisibleValueBoolean) {
          this.$emit('input', visible);
        } else {
          this.$emit('input', visible ? _cloneDeep(this.computedValue) : null);
        }
      }
    }
  }
};
